import type {
  AutocompleteApi,
  AutocompleteOptions} from '@algolia/autocomplete-js';
import {
  autocomplete
} from '@algolia/autocomplete-js'
import '@algolia/autocomplete-theme-classic'
import type {
  MutableRefObject} from 'react';
import {
  createElement,
  Fragment,
  useEffect,
  useRef,
} from 'react'
import { render } from 'react-dom'
import type { StyledComponent } from 'styled-components'

export type AutocompleteProps = {
  autocompleteRef?: MutableRefObject<AutocompleteApi<any> | null>
  StyledDiv?: StyledComponent<'div', any, any, never>
} & Omit<AutocompleteOptions<any>, 'container' | 'renderer' | 'render'>

export function Autocomplete({
  autocompleteRef,
  StyledDiv,
  ...options
}: AutocompleteProps) {
  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) {
      return undefined
    }

    const search = autocomplete({
      container: containerRef.current,
      renderer: { createElement, Fragment },
      render({ children }, root) {
        // TODO: fix typing
        render(children as any, root)
      },

      ...options,
    })

    if (autocompleteRef) {
      autocompleteRef.current = search
    }

    return () => {
      if (autocompleteRef) {
        autocompleteRef.current = null
      }
      search.destroy()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (StyledDiv) {
    return <StyledDiv ref={containerRef} />
  } else {
    return <div ref={containerRef} />
  }
}
